import { apiSliceCRMManager } from "../api/apiSlice";

export const customerCRMApi = apiSliceCRMManager.injectEndpoints({
  endpoints: (builder) => ({
    archiveUnarchiveCustomers: builder.query({
      query: (body) => ({
        url: "ArchiveUnarchiveCustomers",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          console.log(err);
        }
      },
    }),
  }),
});

export const {
  useLazyArchiveUnarchiveCustomersQuery,
} = customerCRMApi;
